"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var url_parse_1 = __importDefault(require("url-parse")); // TODO - should be obsolete


function makeNiceUrlString(url) {
  var match = url.match("http(s)?://(www.)?");

  if (match && match.length) {
    return url.replace(match[0], '');
  } else {
    return url;
  }
}

exports.makeNiceUrlString = makeNiceUrlString;

function prefixWithHotPotatoes(anyUrl) {
  if (anyUrl.startsWith('https://')) {
    return anyUrl;
  } else if (anyUrl.startsWith('http://')) {
    return anyUrl.replace('http', 'https');
  }

  return 'https://' + anyUrl;
}

exports.prefixWithHotPotatoes = prefixWithHotPotatoes;

function trimHotPotatoes(anyUrl) {
  if (anyUrl.startsWith('https://')) {
    return anyUrl.substring('https://'.length);
  }

  return anyUrl;
}

exports.trimHotPotatoes = trimHotPotatoes;

function caseInsentitiveEquals(a, b) {
  if (!a || !b) {
    return false;
  }

  return a.toLowerCase() === b.toLowerCase();
}

exports.caseInsentitiveEquals = caseInsentitiveEquals;

function tryParseUrl(anyUrl) {
  try {
    var url = new url_parse_1.default(anyUrl);
    return {
      valid: true,
      url: url
    };
  } catch (e) {
    return {
      valid: false
    };
  }
}

exports.tryParseUrl = tryParseUrl;

function changeSvgToPng(imgSrc) {
  if (!imgSrc || imgSrc.length === 0) return imgSrc;
  return imgSrc.endsWith('svg') ? imgSrc.replace('.svg', '.png') : imgSrc;
}

exports.changeSvgToPng = changeSvgToPng;
/**
 * use this to make a Base64 encoded string URL friendly,
 * i.e. '+' and '/' are replaced with '-' and '_' also any trailing '='
 * characters are removed
 *
 * @param {String} str the encoded string
 * @returns {String} the URL friendly encoded String
 */

function base64EncodeUrl(str) {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
}

exports.base64EncodeUrl = base64EncodeUrl;
/**
 * Use this to recreate a Base64 encoded string that was made URL friendly
 * using Base64EncodeurlFriendly.
 * '-' and '_' are replaced with '+' and '/' and also it is padded with '+'
 *
 * @param {String} str the encoded string
 * @returns {String} the URL friendly encoded String
 */

function base64DecodeUrl(str) {
  if (str.length % 4 != 0) str += '==='.slice(0, 4 - str.length % 4);
  return str.replace(/-/g, '+').replace(/_/g, '/');
}

exports.base64DecodeUrl = base64DecodeUrl;